import EntitySelectorModalModule from './components/entity-selector-modal/entity-selector-modal.module';
import { EntitySelectorComponent } from './entity-selector.component';
import { EntitySelectorService } from './services/entity-selector.service';

export default angular
  .module('sfMobile.components.entity-selector', [
    'sfMobile.services.localization',
    'sfMobile.services.api-utils',
    'sfMobile.services.static-requests-paginate',
    'sfMobile.components.entity-selector-modal',
    EntitySelectorModalModule,
  ])
  .service('entitySelectorService', EntitySelectorService)
  .component('sfEntitySelector', EntitySelectorComponent).name;
